import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { parseGroundingSections } from "../../utils/groundingPrompts";

function GroundingExcerpt({ body, excerpt, maxSections = 4, maxLen = 200 }) {
  const sections = parseGroundingSections(body || excerpt).slice(0, maxSections);
  if (!sections.length) return null;

  const chunks = [];
  for (const section of sections) {
    const prompt = section.prompt.trim();
    const answer = section.answer.trim();
    chunks.push({ prompt, answer });
  }

  let length = 0;
  const visible = [];
  for (const chunk of chunks) {
    const text = chunk.answer ? `${chunk.prompt} ${chunk.answer}` : chunk.prompt;
    if (length + text.length + (visible.length ? 1 : 0) > maxLen) {
      const room = maxLen - length - (visible.length ? 1 : 0) - chunk.prompt.length - 1;
      if (room > 0 && chunk.answer) {
        visible.push({
          prompt: chunk.prompt,
          answer: `${chunk.answer.slice(0, room - 1).trim()}…`,
        });
      } else if (!visible.length) {
        visible.push({
          prompt: `${chunk.prompt.slice(0, maxLen - 1)}…`,
          answer: "",
        });
      }
      break;
    }
    visible.push(chunk);
    length += text.length + (visible.length > 1 ? 1 : 0);
  }

  return (
    <Typography variant="body2" color="text.secondary" sx={{ mt: 1, lineHeight: 1.65 }}>
      {visible.map((section, index) => (
        <React.Fragment key={`${section.prompt}-${index}`}>
          {index > 0 ? " " : null}
          <Box component="span" sx={{ fontWeight: 700, color: "text.primary" }}>
            {section.prompt}
          </Box>
          {section.answer ? ` ${section.answer}` : null}
        </React.Fragment>
      ))}
    </Typography>
  );
}

export default GroundingExcerpt;
